import { AuthContext } from '@urbanx/agx.auth.client';
import { useQuery } from '@tanstack/react-query';
import { AgencyAgentModel } from 'Api/Agencies/Types/Agencies';
import { agenciesApi } from 'Api/Agencies/agenciesApi';
import { useContext } from 'react';

export const useLoadAgencyAgents = () => {
  const { userAccount, getAuthToken } = useContext(AuthContext);

  const { data: agents, isPending } = useQuery<AgencyAgentModel[] | undefined>({
    queryKey: ['agencyAgents'],
    queryFn: async (ctx) => {
      const token = await getAuthToken();
      if (!token) return [];
      const { data } = await agenciesApi(token).get<AgencyAgentModel[]>('GetAgentsInAgency');

      return data;
    },
    enabled: !!userAccount,
    refetchOnWindowFocus: false,
  });

  return { agents, isPending };
};
